import { render, staticRenderFns } from "./sendConvocatoria.vue?vue&type=template&id=344e73e7&scoped=true&"
import script from "./sendConvocatoria.js?vue&type=script&lang=js&"
export * from "./sendConvocatoria.js?vue&type=script&lang=js&"
import style0 from "./sendConvocatoria.vue?vue&type=style&index=0&id=344e73e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344e73e7",
  null
  
)

export default component.exports